export const TOKEN = 'token';
export const PERMISSIONS = 'permissions';
export const PERMISSION_TOKEN = 'permission_token';
export const POLLING_TOKEN_TIMER = 4 * 60_000; //? 4 minutes
export const FEATURES_KEY = 'features';
export const ACCESS_KEY = 'x_access_key';
export const X_ACCESS_KEY = 'X-ACCESS-KEY';
export const REFRESH_TOKEN = 'refresh_token';
